import React from 'react'
import {strVal, titleCase} from '../../../modules/Utils'

const TitleCaseCell = ({value}) => value && titleCase(strVal({value}, 'value'))
export default TitleCaseCell
